import { ControlSessions } from '@/api/oversight/types';
import { TableHeadData } from '@/pages/Oversight/components/Table';

export type DelegatedAccessTableRow = {
  approval_expires_at: string;
  client_id: number;
  consent_expires_at: string;
  consent_requested_at: string;
  consent_responded_at: string;
  consent_token: string;
  created_at: string;
  end_reason: string;
  id: number;
  impersonation_token_id: string;
  reason: string;
  session_ended_at: string;
  session_expires_at: string;
  session_started_at: string;
  status: string;
  supervisor_id: number;
  supervisor_name: string;
  action: boolean;
};

const delegatedAccessRow = [
  { id: 1, label: 'Cliente', key: 'client_id', width: '300px' },
  { id: 2, label: 'Status', key: 'status', width: '350px' },
  { id: 3, label: 'Motivo', key: 'reason' },
  { id: 4, label: 'Ação', key: 'action', sortable: false, width: '300px' },
] satisfies TableHeadData<DelegatedAccessTableRow>[];

const sectionAdmUserRow = [
  { id: 1, label: 'Início da sessão', key: 'created_at' },
  { id: 2, label: 'Status', key: 'ended_at' },
  { id: 3, label: 'Acessos delegados', key: 'delegated_session_count' },
  { id: 4, label: 'Ação', key: 'action', sortable: false, width: '300px' },
] satisfies TableHeadData<ControlSessions>[];

export { delegatedAccessRow, sectionAdmUserRow };
